// extracted by mini-css-extract-plugin
export var displayNone = "_ur-6";
export var imgContainer = "_ur-2";
export var overflowHidden = "_ur-3";
export var productInfoCardButtonContainer = "_ur-5";
export var productTitleText = "_ur-4";
export var rightArrow = "_ur-1";
export var rightArrowContainer = "_ur-0";